import React, { useContext } from 'react';

import { Code } from '../Components/CodePreview/Code';
import { RunningReactCode } from '../Components/RunningReactCode';
import { Page } from '../Components/Page';
import { darkModeContext } from '../darkModeContext';

export const ReactHookFormExamplev6 = () => {
  const dmContext = useContext(darkModeContext);
  const { reactHookFormExample, fullExample } = getExample(
    dmContext && dmContext.value ? true : false,
  );

  return (
    <Page title="Usage with React Hook Form v6">
      <div>
        <p>
          In order to use the tag-components with{' '}
          <a href="https://react-hook-form.com/" target="blank">
            React Hook Form
          </a>{' '}
          we need to:
        </p>
        <ul>
          <li>
            Pass a <code>name</code> prop to <code>Tag3Input</code> with the field's name
          </li>
          <li>
            Attach React Hook Form's <code>register</code> function to the `inputRef` prop in the{' '}
            <code>Tag3Input</code>
          </li>
        </ul>

        <Code code={fullExample}></Code>
        <div style={{ padding: '20px 0px', borderBottom: '1px solid grey' }}>
          <RunningReactCode
            parentJSX={'Example = () => ' + reactHookFormExample}
            jsx={'<Example />'}
            backgroundVisible={false}
            knobs={{}}
            knobValues={{}}
            events={[]}
          />
        </div>
      </div>
    </Page>
  );
};

function getExample(boo: boolean) {
  const reactHookFormExample = `{
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = data => alert(JSON.stringify(data, null, 2));

  return (
    <div style={{ width: '300px', backgroundColor: "#fff", padding: "20px", boxShadow: "rgb(0 0 0 / 10%) 0px 1px 3px 0px", borderRadius: "4px" }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{marginBottom: "5px"}}>
          <Tag3Label${
            boo ? ' colourScheme="dark"' : ''
          } style={{marginRight: "3px"}}>First name</Tag3Label>
          <Tag3Input${
            boo ? ' colourScheme="dark" inputStyle={{border: "1px solid white"}}' : ''
          } name="firstName" inputRef={ register({ required: true }) } ></Tag3Input>
          {errors.firstName && <Tag3ValidationAlert>You must enter a first name</Tag3ValidationAlert>}
        </div>
        <div style={{marginBottom: "5px"}}>
          <Tag3Label${
            boo ? ' colourScheme="dark"' : ''
          } style={{marginRight: "3px"}}>Last name</Tag3Label>
          <Tag3Input${
            boo ? ' colourScheme="dark" inputStyle={{border: "1px solid white"}}' : ''
          } name="lastName" inputRef={register({ required: true })}></Tag3Input>
          {errors.lastName && <Tag3ValidationAlert>You must enter a last name</Tag3ValidationAlert>}
        </div>
        <div style={{ marginTop: "20px" }}>
          <Tag3SimpleButton${
            boo ? ' colourScheme="dark"' : ''
          } type='submit' accent="midnightblue">Submit</Tag3SimpleButton>
        </div>
      </form>
    </div>
  );
} `;

  const fullExample =
    `import React from 'react';
import { useForm } from 'react-hook-form';
import { TagInput, TagValidationAlert, TagButton, TagLabel } from '@tag/tag-components-react-v3';

export default function RHFandTagComponents() ` + reactHookFormExample;

  return { reactHookFormExample, fullExample };
}
